export default {
    byUnrisdTimelineEntry(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('unrisdTimelineEntryId', id).get()
            )
        )
    }
}
